function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fillRule: "nonzero"
}, React.createElement("path", {
  fill: "#FE0000",
  d: "M176.727 77.926h307.164c15.494 0 28.109 12.616 28.109 28.11v299.927c0 15.494-12.615 28.11-28.109 28.11H28.109C12.615 434.164 0 421.548 0 406.054V256.045h176.727V77.926z"
}), React.createElement("path", {
  fill: "#000095",
  d: "M0 256.045h176.727V77.926H28.109C12.615 77.926 0 90.542 0 106.036v150.009z"
}), React.createElement("path", {
  fill: "#fff",
  d: "M110.63 205.579l-5.337-19.863a25.172 25.172 0 01-9.221 5.305l14.558 14.558zm0-38.593c0-12.339-10.021-22.265-22.265-22.265-12.339 0-22.265 10.021-22.265 22.265 0 12.338 10.021 22.264 22.265 22.264a22.21 22.21 0 0022.265-22.264zm-3.534 16.928l19.859 5.336-14.558-14.536a25.229 25.229 0 01-5.301 9.2zm5.943-11.609l19.947-5.319-19.954-5.309a25.24 25.24 0 01.564 5.309 25.56 25.56 0 01-.557 5.319zm-.656-13.051l14.572-14.53-19.891 5.337a25.242 25.242 0 015.319 9.193zm-7.093-10.967l5.34-19.891-14.53 14.572a25.296 25.296 0 019.19 5.319zm-11.617-5.971l-5.308-19.951-5.319 19.951a25.037 25.037 0 015.316-.565c1.823 0 3.597.196 5.311.565zm-13.067.655l-14.601-14.575 5.397 19.919a25.17 25.17 0 019.204-5.344zm-10.947 7.093l-19.888-5.343 14.558 14.558a25.282 25.282 0 015.33-9.215zm-5.968 11.606l-19.951 5.316 19.951 5.308a25.306 25.306 0 010-10.624zm.649 13.05l-14.569 14.53 19.891-5.336a25.315 25.315 0 01-5.322-9.194zm7.1 10.972l-5.34 19.887 14.537-14.568a25.183 25.183 0 01-9.197-5.319zm11.613 5.967l5.309 19.947 5.315-19.947a25.504 25.504 0 01-5.315.561c-1.82 0-3.598-.192-5.309-.561z"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 512 512"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/taiwan.faea3267.svg";
export { SvgComponent as ReactComponent };